import React from "react";
import Dropdown from "Components/DesignSystem/Dropdown/Dropdown";
import Typography from "Components/DesignSystem/Typography/Typography";

/**
 * "Repeated every [N] Hour/Day/Week" — the interval picker beside the Repeat dropdown.
 *
 * On DS `Dropdown` since § 132. The native `<select>` it replaces styled its own
 * `<option>`s with inline `fontFamily` and `backgroundColor`, which browsers largely
 * ignore, and spaced the row with four literal `&nbsp;` entities on one side and two
 * on the other — layout by non-breaking space.
 *
 * The trailing word is still `Hour` / `Day` / `Week`, produced by the same
 * `charAt(0).toUpperCase() + slice(1).toLowerCase()` on the repeat code.
 */
const RepeatSelect = ({
  labelMessage,
  selectId,
  selectValue,
  selectOptions,
  onChange,
}) => {
  const options = selectOptions.map((item) => ({
    value: String(item),
    label: String(item),
  }));

  const unit = `${labelMessage.charAt(0).toUpperCase()}${labelMessage.slice(1).toLowerCase()}`;

  return (
    <div className="tw-flex tw-items-center tw-gap-2" data-testid="connectors-schedule-interval">
      <Typography variant="caption-metadata" as="span" className="tw-text-ink-secondary">
        Repeated every
      </Typography>
      <Dropdown
        label=""
        aria-label={`Repeat interval in ${unit.toLowerCase()}s`}
        id={selectId}
        size="sm"
        className="tw-w-[80px]"
        options={options}
        value={String(selectValue)}
        /* The caller still handles `(id, value)`, so the id it expects on
           `e.target.id` is passed explicitly rather than read back off the DOM. */
        onChange={(value) => onChange(selectId, String(value))}
        usePortal
        data-testid={`connectors-schedule-interval-${selectId}`}
      />
      <Typography variant="caption-metadata" as="span" className="tw-text-ink-secondary">
        {unit}
      </Typography>
    </div>
  );
};

export default RepeatSelect;
